// extracted by mini-css-extract-plugin
export var image = "ImageGridModule-module--image--53f2a";
export var imageContainer = "ImageGridModule-module--imageContainer--c9836";
export var imageTitle = "ImageGridModule-module--imageTitle--2f7be";
export var imagesContainer = "ImageGridModule-module--imagesContainer--2061a";
export var loading = "ImageGridModule-module--loading--b9ab4";